import { filter, map, merge, Observable, scan } from 'rxjs';

export function skipBetween<T>(start$: Observable<unknown>, end$: Observable<unknown>) {
  return (observable: Observable<T>): Observable<T> => {
    const initialMarker = 'SKIP_BETWEEN/INITIAL_MARKER' as const;
    const startMarker = 'SKIP_BETWEEN/START_MARKER' as const;
    const endMarker = 'SKIP_BETWEEN/END_MARKER' as const;
    type Marker = typeof initialMarker | typeof startMarker | typeof endMarker;

    function isNotMarker<A extends unknown>(x: A): x is Exclude<A, Marker> {
      return x !== initialMarker && x !== startMarker && x !== endMarker;
    }

    return merge(
      start$.pipe(map(() => startMarker)),
      observable,
      end$.pipe(map(() => endMarker))
    ).pipe(
      scan<T | Marker, [boolean, T | Marker]>(
        (acc, x) => {
          if (x === startMarker) {
            return [false, x];
          }
          if (x === endMarker) {
            return [true, x];
          }
          return [acc[0], x];
        },
        [true, initialMarker]
      ),
      filter(([x]) => x),
      map(([, v]) => v),
      filter(isNotMarker)
    );
  };
}
